import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";
import { legacy } from "@styles/emotion-styles/palette";

export const buttonsContainer = css`
  display: flex;

  @media (max-width: ${dimensions.tablet}) {
    flex-direction: row-reverse;
  }
`;

export const navBar = (theme: Theme) => css`
  display: flex;
  padding: 1rem;
  position: sticky;
  top: 0;
  background: ${theme.surface.level1};
  border-bottom: 1px solid ${theme.system.borderBase};
  z-index: ${layers.indexNavBar};
`;

export const button = css`
  margin-right: 1rem;

  @media (max-width: ${dimensions.tablet}) {
    margin: 0 0 0 0.5rem;
  }
`;

export const svgContainer = css`
  width: 7rem;
`;

export const homeWithCoBranding = css`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;

  svg {
    height: 36px;
  }

  svg path {
    fill: ${legacy.greenery};
  }
`;

export const divider = (theme: Theme) => css`
  height: 36px;
  width: 1px;
  background-color: ${theme.separator.base};
  margin: 0 1rem;
`;

export const coBrandingLogo = css`
  height: 36px;
  width: 36px;
  object-fit: contain;
`;
